import Indicator, { IndicatorType } from '../types/Indicator'

const AverageDirectionalIndex: Indicator = {
  type: IndicatorType.OVERLAY,
  value: 'averageDirectionalIndex',
  label: 'Average Directional Index',
  nickname: 'ADX',
  fields: ['mdi', 'pdi', 'adx'],
  params: {
    period: 14,
  },
}

export default AverageDirectionalIndex
